const $ = require('jquery');
const JS_PREFIX = 'js-steps';

class Steps {
  dom = {
    $el: null,
    $steps: null
  };

  constructor(selector) {
    this.dom.$el = $(selector);

    if(!this.dom.$el.length) {
      return;
    }

    this.dom.$steps = this.dom.$el.find('.' + JS_PREFIX + '__step');
  }

  setActiveStep(stepNumber) {
    this.dom.$steps.each(function () {
      const $step = $(this);

      if(parseInt($step.data('step')) === parseInt(stepNumber)) {
        $step.addClass('is-active');
      } else if($step.hasClass('is-active')) {
        $step.removeClass('is-active');
      }
    });
  }
}

export { Steps }
